import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import Notification from "../../components/Notifications/Notification";
import './Header.scss';
export default function Header() {
    const [info, setInfo] = useState(null);   
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const response = await apiFetch({ path: '/ultimate-security/v1/plugin-info' });
        
                // Save to localStorage
                localStorage.setItem("plusInfo", JSON.stringify(response));
        
                // Update state
                setInfo(response);
            } catch (error) {
                console.error("Error fetching info:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedInfo = localStorage.getItem("plusInfo");
        if (storedInfo) {
            setInfo(JSON.parse(storedInfo));
        } else {
            fetchInfo();
        }
    }, []);
     // Toggle notifications panel
     const [showNotifications, setShowNotifications] = useState(false);

    // Toggle notifications panel
    const toggleNotifications = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
    };

    return (
        <div className="ultimate-security-topbar background-purple-90 text-white">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-xl-5 mb-3 mb-xl-0">
                        <div className="d-flex justify-content-center justify-content-lg-start align-items-center topbar-left">
                            <img className="plugin-logo" src={ultimate_security_ajax_obj.imageUrl+'icon.svg'}/>
                            <div className="plugin-name pl-heading fw-700">{__( 'Ultimate Security', "ultimate-security" )}</div>
                            <ul className="d-flex align-items-center mb-0 gap-3 mt-2">
                                { <li className="pl-heading-1 fw-600 dashboard-link">
                                    <Link to="/">
                                        <img src={ultimate_security_ajax_obj.imageUrl+'dashboard.svg'} alt="plugin-icon"/>
                                        {__( 'Dashboard', "ultimate-security" )}
                                    </Link>
                                </li> }
                                <li className="pl-heading-1 fw-600">
                                    <Link to="/login/active-logins/settings">
                                        <img src={ultimate_security_ajax_obj.imageUrl+'settings.svg'} alt="plugin-icon"/>
                                        {__( 'Settings', "ultimate-security" )}
                                    </Link>
                                </li>
                            </ul>
                        </div>                        
                    </div>
                    <div className="col-xl-7">
                        <div className="row g-0 justify-content-center justify-content-lg-end align-items-center topbar-right">                                
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/ultimate-security/" target="_blank">
                                <img src={ultimate_security_ajax_obj.imageUrl+'support.svg'} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/ultimate-security/reviews/#new-post" target="_blank">
                                    <img src={ultimate_security_ajax_obj.imageUrl+'featured.svg'} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a
                                    href="#"
                                    onClick={toggleNotifications}
                                    className={`nav-link ${showNotifications ? "active" : ""}`}
                                >
                                     <img src={ultimate_security_ajax_obj.imageUrl+'notification.svg'} alt="plugin-icon"/>
                                </a>
                                
                                {showNotifications && (
                                    <Notification onClose={() => setShowNotifications(false)} />
                                )}
                            </div>
                            <div className="col-auto topbar-right-unit">
                                <a href="https://www.wpultimatesecurity.com" target="_blank">
                                    <img className="question" src={ultimate_security_ajax_obj.imageUrl+'pl_logo.svg'}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>                    
            </div>
        </div>
    )
}
